<div class="modal-container" (click)="closeTimeDropdown()" *transloco="let t; prefix: 'workOrder'">
  <div class="modal-container__header">
    <span class="modal-container__header-title">{{ t('modals.scheduleAssign.title') }}</span>
    <button class="modal-container__header-btn" (click)="closeModal()" [title]="'common.close' | transloco">
      <svg class="modal-container__header-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1959 6.34399L11.9529 10.586L7.71087 6.34399L6.29688 7.75799L10.5389 12L6.29688 16.242L7.71087 17.656L11.9529 13.414L16.1959 17.656L17.6099 16.242L13.3679 12L17.6099 7.75799L16.1959 6.34399Z" fill="#9FA1A4"/>
      </svg>
    </button>
  </div>

  <!-- Progress Indicator -->
  <div class="progress-indicator">
    <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
      <span class="step-label">{{ t('modals.scheduleAssign.stepSchedule') }}</span>
      <div class="step-bar"></div>
    </div>
    <div class="step" [class.active]="currentStep === 2">
      <span class="step-label">{{ t('modals.scheduleAssign.stepAssignTechnician') }}</span>
      <div class="step-bar"></div>
    </div>
  </div>

  <div class="modal-container__body">
    <!-- Step 1: Schedule -->
    @if (currentStep === 1) {
      <div class="step-content">
        <!-- Schedule Date -->
        <div class="modal-form__field">
          <app-flatpickr-date-picker
            [label]="t('modals.shared.scheduleDate')"
            [(value)]="formData.scheduledDate"
            (valueChange)="onScheduledDateChange($event)"
            [minDate]="'today'"
            [altFormat]="'d/m/Y'"
            [placeholder]="t('modals.shared.datePlaceholder')"
            [required]="true">
          </app-flatpickr-date-picker>
          @if (touched.scheduledDate && formData.scheduledDate === '') {
            <div class="error-message">{{ t('modals.scheduleAssign.scheduleDateRequired') }}</div>
          }
        </div>

        <!-- Schedule Time -->
        <div class="modal-form__field" (click)="$event.stopPropagation()">
          <label class="modal-label">{{ t('modals.scheduleAssign.scheduleTime') }} <span class="required">*</span></label>
          <div class="dropdown-input-wrapper" (click)="toggleTimeDropdown()">
            <input class="modal-input" type="text" [placeholder]="t('modals.scheduleAssign.selectTime')" [value]="formData.scheduledTime" readonly />
            <i class="ph ph-timer dropdown-icon"></i>
          </div>
          @if (timeDropdownOpen) {
            <ul class="modal-dropdown-menu time-dropdown">
              @for (time of timeOptions; track time) {
                <li (click)="selectTime(time)">{{ time }}</li>
              }
            </ul>
          }
          @if (touched.scheduledTime && formData.scheduledTime === '') {
            <div class="error-message">{{ t('modals.scheduleAssign.scheduleTimeRequired') }}</div>
          }
        </div>
      </div>
    }

    <!-- Step 2: Assign Technician -->
    @if (currentStep === 2) {
      <div class="step-content">
        <!-- Search -->
        <div class="search-wrapper">
          <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#9FA1A4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17.5 17.5L13.875 13.875" stroke="#9FA1A4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input
            type="text"
            class="search-input"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            [placeholder]="t('modals.scheduleAssign.searchPlaceholder')"
          />
        </div>

        <!-- Assigned To Section -->
        @if (selectedTechnicians.length > 0) {
          <div class="assigned-section">
            <span class="section-label">{{ t('modals.shared.assignedTo') }}</span>
            @for (technician of selectedTechnicians; track technician.technicianId) {
              <div class="technician-item selected removable" (click)="unassignTechnician(technician)">
                <app-avatar class="technician-avatar" [name]="technician.technicianName" [size]="40"></app-avatar>
                <div class="technician-details">
                  <span class="technician-name">{{ technician.technicianName }}</span>
                  <span class="technician-role">{{ technician.jobTitle }}</span>
                </div>
              </div>
            }
          </div>
        }

        <!-- Technicians List -->
        <div class="technicians-section">
          <span class="section-label">{{ t('modals.scheduleAssign.technicians') }}</span>

          @if (isLoadingTechnicians) {
            <div class="loading-state">
              <div class="spinner-border spinner-border-sm text-danger"></div>
              <span>{{ t('modals.scheduleAssign.loadingTechnicians') }}</span>
            </div>
          } @else {
            <div class="technicians-list">
              @for (technician of filteredTechnicians; track technician.technicianId) {
                <div
                  class="technician-item"
                  [class.selected]="isTechnicianSelected(technician.technicianId)"
                  [class.disabled]="isTechnicianSelected(technician.technicianId)"
                  (click)="assignTechnician(technician)">
                  <app-avatar class="technician-avatar" [name]="technician.technicianName" [size]="40"></app-avatar>
                  <div class="technician-details">
                    <span class="technician-name">{{ technician.technicianName }}</span>
                    <span class="technician-role">{{ technician.jobTitle }}</span>
                  </div>
                </div>
              }

              @if (filteredTechnicians.length === 0) {
                <div class="empty-state">
                  <span>{{ t('modals.scheduleAssign.noTechniciansFound') }}</span>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Action Buttons -->
  <div class="modal-actions">
    <button class="modal-btn cancel" (click)="currentStep > 1 ? previousStep() : closeModal()">
      {{ currentStep > 1 ? t('modals.scheduleAssign.back') : ('common.cancel' | transloco) }}
    </button>

    @if (currentStep < totalSteps) {
      <button class="modal-btn next" [disabled]="!canGoNext" (click)="nextStep()">
        {{ 'common.next' | transloco }}
      </button>
    } @else {
      <button class="modal-btn save" [disabled]="!canSave || isLoading" (click)="save()">
        @if (isLoading) {
          <span class="spinner-border spinner-border-sm"></span>
        } @else {
          <span>{{ t('modals.scheduleAssign.save') }}</span>
        }
      </button>
    }
  </div>
</div>
